import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import SvgChecklistIcon from "@Components/CustomIcon/SvgCheckListIcon"
import SvgConstantsIcon from "@Components/CustomIcon/SvgConstantsIcon"
import SvgEntretientSuiviIcon from "@Components/CustomIcon/SvgEntretientSuiviIcon"
import SvgFichePatientIcon from "@Components/CustomIcon/SvgFichePatientIcon"
import SvgObjectifIcon from "@Components/CustomIcon/SvgObjectifIcon"
import SvgOutilIcon from "@Components/CustomIcon/SvgOutilsIcon"
import SvgRappelIcon from "@Components/CustomIcon/SvgRappelIcon"
import SvgTropheeIcon from "@Components/CustomIcon/SvgTropheeIcon"
import SvgDiagnostic from "@Components/CustomIcon/SvgDiagnostic";
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { FollowUpItemCard } from "@Components/FollowUp/FollowUpCardItem"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import React from "react"
import { ScrollView } from "react-native"

const FollowUp = ({ navigation }) => {
    const followUps = [
        {
            title: "Suivi des constantes",
            icon: <SvgConstantsIcon height={27} width={27} />,
            bgColor: baseColors.green.primary,
            // onPress: () => navigation.navigate("ConstantFollowUpStack")
            onPress: () => navigation.navigate("ConstantFollowUp")
        },
        {
            title: "Fiche patient",
            icon: <SvgFichePatientIcon height={27} width={27} />,
            bgColor: baseColors.orange.primary,
            onPress: () => navigation.navigate("PatientFolder")
        },
        {
            title: "Mes objectifs",
            icon: <SvgObjectifIcon height={27} width={27} />,
            bgColor: baseColors.green.primary,
            onPress: () => navigation.navigate("Goals")
        },
        {
            title: "Mes micro-objectifs",
            icon: <SvgObjectifIcon height={27} width={27} />,
            bgColor: baseColors.green.primary,
            onPress: () => navigation.navigate("MicroGoals")
        },
        {
            title: "Mes rappels",
            icon: <SvgRappelIcon height={27} width={27} />,
            bgColor: baseColors.orange.primary,
            onPress: () => navigation.navigate("ReminderHome")
            // onPress: () => navigation.navigate("ReminderStack")
        },
        {
            title: "Entretiens de suivi/éval.",
            icon: <SvgEntretientSuiviIcon height={27} width={27} />,
            bgColor: baseColors.green.primary,
            onPress: () => navigation.navigate("AppointmentHome")
        },
        {
            title: "Mes compte-rendus",
            icon: <SvgChecklistIcon height={27} width={27} />,
            bgColor: baseColors.orange.primary,
            onPress: () => navigation.navigate("ReportHome")
        },
        {
            title: "Ma boîte à outils",
            icon: <SvgOutilIcon height={27} width={27} />,
            bgColor: baseColors.green.primary,
            onPress: () => navigation.navigate("ToolBoxHome")
        },
        {
            title: "Je m'évalue",
            icon: <SvgTropheeIcon height={27} width={27} />,
            bgColor: baseColors.orange.primary,
            onPress: () => navigation.navigate("EvaluationStack")
        },
        {
            title: "Score DE",
            icon: <SvgDiagnostic height={27} width={27} />,
            bgColor: baseColors.green.primary,
            onPress: () => navigation.navigate("ScoreDERadar")
        }
    ]
    return (
        <ContainerStackScreen>
            <BreeSerifText color={baseColors.green.primary} fontSize={24}>
                Mon suivi
            </BreeSerifText>
            <Spacer height={10} />
            <OpenSansText fontSize={16}>
                Ici, vous pouvez suivre votre évolution grâce à différentes sections.
            </OpenSansText>
            <Spacer height={5} />
            <CustomScrollview>
                {followUps.map((item, index) => (
                    <FollowUpItemCard key={index} {...item} />
                ))}
            </CustomScrollview>
        </ContainerStackScreen>
    )
}

export default FollowUp
